import { Button, Stack } from "@mui/material";
import { ActivitiesFilterSimpleItem } from "web_myplann/Activities/Filters/Components/ActivitiesFilterSimpleItem";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import {
	activitiesFiltersState,
	defaultActivitiesFiltersState,
} from "web_myplann/Shared/State/activitiesFiltersAtom";
import { DEFAULT_ROUTE } from "web_myplann/Utils/constants";
import { allActivityCreated, allActivityTypes } from "web_myplann/Utils/types";
import "dayjs/locale/cs";
import { useAtomValue, useSetAtom } from "jotai";
import { RotateCw } from "lucide-react";
import { type FC, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
	type: "types" | "created";
};

export const ActivitiesFilterSimplePage: FC<Props> = ({ type }) => {
	const { t } = useResource();
	const navigate = useNavigate();

	const allData = type === "types" ? allActivityTypes : allActivityCreated;
	const title =
		type === "types"
			? t(Resources.Activity.Filters.Type.title)
			: t(Resources.Activity.Filters.Created.title);

	const { [type]: defaultData } = useAtomValue(activitiesFiltersState);
	const setFiltersState = useSetAtom(activitiesFiltersState);

	const [data, setData] = useState<string[]>(defaultData);

	const handleReset = useCallback(() => {
		setData(defaultActivitiesFiltersState[type]);
		setFiltersState((prev) => ({
			...prev,
			[type]: defaultActivitiesFiltersState[type],
		}));
	}, [setData, setFiltersState]);

	const handleAccept = () => {
		setFiltersState((prev) => ({
			...prev,
			[type]: data,
		}));

		navigate(-1);
	};

	return (
		<MyPlannLayout
			topBar={
				<NavigationHeader
					title={title}
					defaultRoute={DEFAULT_ROUTE}
					endComponent={<RotateCw size={16} onClick={handleReset} />}
				/>
			}
		>
			<Stack paddingTop={1.6} gap={1.6}>
				{allData.map((e) => (
					<ActivitiesFilterSimpleItem
						key={e}
						text={e}
						selected={data.includes(e)}
						onClick={setData}
					/>
				))}

				<Button
					variant="contained"
					color="primary"
					type="button"
					fullWidth
					onClick={handleAccept}
				>
					{t(Resources.Common.Apply)}
				</Button>
			</Stack>
		</MyPlannLayout>
	);
};
